<ng-container *transloco="let t">
@for (task of filteredSortedTasks; track task.taskId; let i = $index) {
<div class="d-flex align-items-stretch">
  <div class="card w-100 mb-4 border border-2 mobile-task-card" [class.mobile-expanded]="isTaskExpanded(task.taskId)">

    <!-- Mobile: compact accordion summary row (hidden on desktop) -->
    <div class="mobile-task-summary d-none" role="button" tabindex="0"
      [attr.aria-expanded]="isTaskExpanded(task.taskId)" (click)="toggleTaskExpanded(task.taskId)"
      (keydown)="onSummaryKeydown($event, task.taskId)">
      <div class="mobile-task-summary-left">
        <div class="mobile-task-title">{{ (task | taskText:'docType') || (task | taskText:'description') || t(fallbackTaskTitleKey(task)) }}</div>
        <div class="mobile-task-meta">
          @if(task.borrowerId){
            <span class="mobile-borrower-name">{{ task?.borrowerName || t('portal.tasks.unknown') }}</span>
            <span class="mobile-meta-dot">&middot;</span>
          }
          @if(!isSubmitted){
            @if (task?.dueDate | dueDate; as due) {
              <span [class.mobile-overdue]="due.overdue">{{ due.overdue ? t('portal.tasks.overdue') + ' · ' : t('portal.tasks.due') + ' ' }}{{ due.date }}</span>
            }
          }
        </div>
      </div>
      <div class="mobile-task-summary-right">
        @if(task.borrowerTaskStatus === 'Submitted'){
          <span class="badge rounded-pill bg-primary mobile-status-badge">{{ t('portal.tasks.submitted') }}</span>
        }
        @if(task.borrowerTaskStatus === 'Rejected'){
          <span class="badge rounded-pill bg-alert text-dark mobile-status-badge">{{ t('portal.tasks.rejected') }}</span>
        }
        @if(task.borrowerTaskStatus === 'Completed'){
          <span class="badge rounded-pill bg-success text-dark mobile-status-badge">{{ t('portal.tasks.completed') }}</span>
        }
        @if(task.borrowerFacingNote && task.borrowerTaskStatus === 'Rejected'){
          <span class="badge rounded-pill bg-warning text-dark mobile-status-badge">{{ t('portal.tasks.urgent') }}</span>
        }
        @if(task.borrowerFacingNote && task.borrowerTaskStatus !== 'Rejected'){
          <span class="badge rounded-pill bg-light text-dark mobile-status-badge">{{ t('portal.tasks.newMessage') }}</span>
        }
        <i class="fas fa-chevron-down mobile-chevron" [class.rotated]="isTaskExpanded(task.taskId)"></i>
      </div>
    </div>

    <!-- Mobile: expandable action area (hidden until expanded; uses mobile-expand-content class) -->
    <div class="mobile-expand-content">
      <!-- Task description & due date details -->
      <div class="mobile-detail-section">
        @if (task | taskText:'distinctDescription'; as description) {
          <div class="mobile-detail-row">
            <span class="mobile-detail-label">{{ t('portal.tasks.description') }}</span>
            <span class="mobile-detail-value">{{ description }}</span>
          </div>
        }
        @if (isSubmitted) {
          <div class="mobile-detail-row">
            <span class="mobile-detail-label">{{ t(taskStatusLabel(task)) }}:</span>
            <span class="mobile-detail-value">{{ (task?.submittedDate || task?.approvedDate) | date:'MMM d, y, h:mm a' }}</span>
          </div>
        }
      </div>

      <!-- Action buttons row -->
      <div class="mobile-actions-row">
        @if(task.allowUpload){
          <a href="javascript:void(0)" class="btn btn-sm bp-primary-bg-color"
            (click)="openAddFiles(task)">
            <i class="fas fa-paperclip text-white"></i> {{ t('portal.tasks.addFiles') }}
          </a>
        }
        @if(isBorrowerPortal && task.borrowerTaskType === 'GatherPayment'){
          <a href="javascript:void(0)"
            class="btn btn-sm bp-primary-bg-color" (click)="openPaymentInfo(task)">{{ t('portal.tasks.addPaymentInfo') }}
          </a>
        }
        @if(shouldShowEsignDocumentBtn(task)){
          <a href="javascript:void(0)" [ngClass]="{ disabled: isEsignTaskDisabled(task) }" [attr.aria-disabled]="isEsignTaskDisabled(task)" class="btn btn-sm bp-primary-bg-color" (click)="openEsignDocument(task)">{{
            !doNotEnforceChronologicalOrder &&
            enabledTaskIdForESign != task.taskId &&
            task.borrowerTaskType === "LosEsign"
            ? t('portal.tasks.eSignAboveDocFirst')
            : t('portal.tasks.eSignDocument')
            }}
          </a>
        }
        @if(shouldShowCreditAuthBtn(task)){
          <a href="javascript:void(0)"
            class="btn btn-sm bp-primary-bg-color" (click)="openCreditAuthConsent(task)">
            {{ t('portal.tasks.authorizeCreditCheck') }}
          </a>
        }
        @if(task.borrowerTaskType === 'RequestDocument' &&
            isBorrowerPortal &&
            !task.isAgentTask &&
            task.allowMarkNA && !isCompanyPhm){
          <a href="javascript:void(0)"
            class="btn btn-sm btn-outline-secondary mobile-na-btn"
            (click)="onTaskNotApplicableChanged(task, true)">
            {{ t('portal.tasks.notApplicable') }}
          </a>
        }
        @if(task.templateDocumentUrl){
          <a href="javascript:void(0)" class="btn btn-sm btn-outline-secondary" (click)="goToLink(task.templateDocumentUrl)">
            <i class="far fa-eye"></i> {{ t('portal.tasks.templateDoc') }}
          </a>
        }
      </div>

      <!-- Borrower facing note -->
      @if(task.borrowerFacingNote){
        <div class="mobile-note-section">
          <div class="mobile-note-header">
            <div class="mobile-note-text">
              <small class="text-muted d-block mb-1">{{ t('portal.tasks.loanTeamMessage') }}</small>
              <p [innerHTML]="(task | taskText:'borrowerFacingNote') | htmlText" class="mb-0"></p>
            </div>
            <div class="mobile-note-expand-icon" role="button" tabindex="0"
              [attr.aria-label]="t('portal.tasks.toggleMessageHistory')"
              [attr.aria-expanded]="isNoteExpanded(task.taskId)"
              (click)="toggleExpand(task.taskId)"
              (keydown)="onNoteToggleKeydown($event, task.taskId)">
              <i class="fas" [ngClass]="isNoteExpanded(task.taskId) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
          </div>
          @if(isNoteExpanded(task.taskId)){
            <div class="w-100 mt-2">
              @if(isNoteLoading(task.taskId)){
                <div class="d-flex justify-content-center align-items-center py-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only"></span>
                  </div>
                  <span class="ml-4"> {{ t('portal.tasks.pleaseWait') }}</span>
                </div>
              }
              @else {
                <hr class="my-2">
                @if(getOtherNotes(task.taskId).length > 0){
                  <ul class="list-unstyled mb-0">
                    @for (note of getOtherNotes(task.taskId); track note.messageId) {
                      <li class="py-2 border-bottom">
                        <span>{{ note.content }}</span>
                        <p class="text-muted mb-0">{{ note.dateInserted | date: 'MMM d, y, h:mm:ss a' }}</p>
                      </li>
                    }
                  </ul>
                }
                @if(getOtherNotes(task.taskId).length === 0){
                  <div class="text-center text-muted py-2">
                    {{ t('portal.tasks.noOtherNotes') }}
                  </div>
                }
              }
            </div>
          }
        </div>
      }

      <!-- Clickable attached documents list (parity with desktop) -->
      @if(task['attachedDocuments']?.length){
        <div class="mobile-docs-list">
          @for (document of task['attachedDocuments']; track document.fileGuid) {
            <view-document [document]="document"></view-document>
          }
        </div>
      }

      @if(shouldShowEsignDocumentEmailTextMessage(task)){
        <p class="text-danger mobile-esign-msg">
          {{ t('portal.tasks.docusignEmailMessage') }}
        </p>
      }
    </div>

    <!-- Desktop: full card layout (hidden on mobile via CSS) -->
    <div class="desktop-task-content">
      <div class="card-header p-4 d-flex align-items-center justify-content-between border-bottom-2">
        <div class="flex-shrink-1 flex-grow-1 me-3" [class.has-na]="
          task.borrowerTaskType === 'RequestDocument' && isBorrowerPortal && !task.isAgentTask && task.allowMarkNA &&
          !isCompanyPhm" style="min-width: 0;">
          <h4 class="mb-0 text-truncate" style="max-width: 55rem;">
            {{ (task | taskText:'docType') || (task | taskText:'description') || t(fallbackTaskTitleKey(task)) }}
          </h4>
          @if (task | taskText:'distinctDescription'; as description) {
          <span class="text-gray-700 fs-8 fw-bold d-block pt-2">
            {{ description }}
          </span>
          }
          @if(task.borrowerTaskType === 'RequestDocument' &&
              isBorrowerPortal &&
              !task.isAgentTask &&
              task.allowMarkNA && !isCompanyPhm){
            <div class="form-check mt-3 mb-2">
            <input type="checkbox" class="form-check-input" id="taskNotApplicable{{ task.taskId }}"
              name="taskNotApplicable{{ task.taskId }}" [ngModel]="isTaskNotApplicable(task)"
              (ngModelChange)="onTaskNotApplicableChanged(task, $event)" />
            <label class="form-check-label" for="taskNotApplicable{{ task.taskId }}">
              {{ t('portal.tasks.notApplicable') }}
            </label>
          </div>
          }

        </div>
        <div class="d-flex flex-column align-items-end justify-content-end mt-2">
          <div>
            @if(task.allowUpload){
           <a href="javascript:void(0)" class="btn btn-sm bp-primary-bg-color float-end min-w-110"
              (click)="openAddFiles(task)">
              <i class="fas fa-paperclip text-white"></i> {{ t('portal.tasks.addFiles') }}
            </a>
            }
           @if(isBorrowerPortal && task.borrowerTaskType === 'GatherPayment'){
             <a href="javascript:void(0)"
              class="btn btn-sm bp-primary-bg-color mx-2" (click)="openPaymentInfo(task)">{{ t('portal.tasks.addPaymentInfo') }}
            </a>
           }
          @if(shouldShowEsignDocumentBtn(task)){
            <a href="javascript:void(0)" [ngClass]="{ disabled: isEsignTaskDisabled(task) }" [attr.aria-disabled]="isEsignTaskDisabled(task)" class="btn btn-sm bp-primary-bg-color mx-2" (click)="openEsignDocument(task)">{{
              !doNotEnforceChronologicalOrder &&
              enabledTaskIdForESign != task.taskId &&
              task.borrowerTaskType === "LosEsign"
              ? t('portal.tasks.eSignAboveDocFirst')
              : t('portal.tasks.eSignDocument')
              }}
            </a>
          }
            @if(shouldShowCreditAuthBtn(task)){
            <a href="javascript:void(0)"
              class="btn btn-sm bp-primary-bg-color mx-2" (click)="openCreditAuthConsent(task)">
              {{ t('portal.tasks.authorizeCreditCheck') }}
            </a>
            }

          </div>
        </div>
      </div>
      <div class="card-body p-4">
        <div class="d-flex align-items-center justify-content-between align-xs-items-start flex-xs-column">
          <div class="d-flex">
            @if(task.borrowerId){
            <div class="d-flex align-items-center">
              <span
                class="bp-contact-name-circle p-2 rounded-circle fw-bold d-flex align-items-center justify-content-center">
                {{ task.borrowerName?.charAt(0) }}
              </span>
            </div>
            }

            <div class="d-flex flex-column ms-2">
              <strong>{{ task?.borrowerName || t('portal.tasks.unknown') }}</strong>
              @if(!isSubmitted){
              @if (task?.dueDate | dueDate; as due) {
                <span class="text-nowrap" [class.text-danger]="due.overdue">{{ due.overdue ? t('portal.tasks.overdue') + ' · ' : t('portal.tasks.due') + ' ' }}{{ due.date }}</span>
              }
              }
              @if(isSubmitted){
              <span class="text-nowrap" >{{ (task?.submittedDate || task?.approvedDate) |
                date:'MM/dd/yy, h:mm a' }}</span>
              }

            </div>
          </div>
          <div class="mt-xs-5">
            @if(task.borrowerFacingNote && task.borrowerTaskStatus === 'Rejected'){
            <span class="badge rounded-pill bg-warning text-dark task-status-badge">{{ t('portal.tasks.urgentMessage') }}</span>
            }
            @if(task.borrowerFacingNote && task.borrowerTaskStatus !== 'Rejected'){
              <span class="badge rounded-pill bg-light text-dark task-status-badge">{{ t('portal.tasks.newMessage') }}</span>
            }
            @if(task.linkedDocuments && task.linkedDocuments.length){
            <span class="badge rounded-pill bg-light-primary text-dark task-status-badge">{{ task.linkedDocuments.length }} {{ t('portal.tasks.documents') }}</span>
            }
            @if(task.borrowerTaskStatus === 'Pending'){
            <span class="badge rounded-pill bg-light-warning text-dark task-status-badge">{{ t('portal.tasks.pending') }}</span>
            }
            @if(task.borrowerTaskStatus === 'Submitted'){
            <span class="badge rounded-pill bg-primary task-status-badge">{{ t('portal.tasks.submitted') }}</span>
            }
            @if(task.borrowerTaskStatus === 'Rejected'){
            <span class="badge rounded-pill bg-alert text-dark task-status-badge">{{ t('portal.tasks.rejected') }}</span>
            }
            @if(task.borrowerTaskStatus === 'Completed'){
            <span class="badge rounded-pill bg-success text-dark task-status-badge">{{ t('portal.tasks.completed') }}</span>
            }
            @if(task.templateDocumentUrl){
            <a title="{{ t('portal.tasks.viewTemplateDoc') }}" class="mx-2 bp-link"
              (click)="goToLink(task.templateDocumentUrl)">
              <i class="far fa-eye"></i> {{ t('portal.tasks.templateDoc') }}
            </a>
            }
          </div>
        </div>

        <div class="row my-2">
          @if(task.borrowerFacingNote){
          <div class="borrower-facing-note my-2 p-3 mx-4" [ngClass]="{'expanded': isNoteExpanded(task.taskId)}"
            style="max-width: max-content !important">
            <div class="note-content d-flex align-items-center justify-content-between">
              <div class="note-text flex-grow-1 mr-3">
                <small class="text-muted d-block mb-1">{{ t('portal.tasks.loanTeamMessage') }}</small>
                <p [innerHTML]="(task | taskText:'borrowerFacingNote') | htmlText" class="mb-0"></p>
              </div>

              <div class="expand-icon" style="margin-left: 2rem;" role="button" tabindex="0"
                [attr.aria-label]="t('portal.tasks.toggleMessageHistory')"
                [attr.aria-expanded]="isNoteExpanded(task.taskId)" (click)="toggleExpand(task.taskId)"
                (keydown)="onNoteToggleKeydown($event, task.taskId)">
                <i class="fas" [ngClass]="isNoteExpanded(task.taskId) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </div>
            </div>
            @if(isNoteExpanded(task.taskId)){
            <div class="w-100 mt-3">
              @if(isNoteLoading(task.taskId)){
              <ng-container >
                <div class="d-flex justify-content-center align-items-center py-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only"></span>
                  </div>
                  <span class="ml-4"> {{ t('portal.tasks.pleaseWait') }}</span>
                </div>
              </ng-container>
              }
            @else {
             <ng-container>
                <hr class="my-2">
                @if(getOtherNotes(task.taskId).length > 0){
                <div>
                  <ul class="list-unstyled mb-0">
                   @for (note of getOtherNotes(task.taskId); track note.messageId) {
                    <li class="py-2 border-bottom">
                      <span>{{ note.content }}</span>
                      <p class="text-muted mb-0">{{ note.dateInserted | date: 'MMM d, y, h:mm:ss a' }}</p>
                    </li>
                   }
                  </ul>
                </div>
                }
                @if(getOtherNotes(task.taskId).length === 0){
                 <div class="text-center text-muted py-2">
                   {{ t('portal.tasks.noOtherNotes') }}
                 </div>
                }
              </ng-container>
              }


            </div>
            }

          </div>
          }
        </div>

        @if(task['attachedDocuments']?.length){
        <div class="row my-2">
          @for (document of task['attachedDocuments']; track document.fileGuid) {
          <view-document [document]="document" ></view-document>
          }
        </div>
        }

        @if(shouldShowEsignDocumentEmailTextMessage(task)){
        <p class="text-danger pt-0 px-3 pb-3" >
          {{ t('portal.tasks.docusignEmailMessage') }}
        </p>
        }

      </div>
    </div>

  </div>
</div>
}
</ng-container>
